import React from 'react'
import ReservationBuilderCustomerInformation from '../ReservationBuilderCustomerInformation'

export default class ReservationBuilderCustomerInformationStep extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <fieldset>
        <div className="customer-information">
          <div className="row">

            <div className="col-md-12">
              <ReservationBuilderCustomerInformation {...this.props} />
            </div>

          </div>
        </div>
      </fieldset>
    );
  }

};
